import React, { useMemo } from "react";
import { useRootElement } from "../context";
import type { PopupProps } from "./types";

import { MapGLPopup } from "./MapGL";

export const Popup = (props: PopupProps) => {
  const { mapProvider } = useRootElement();

  const PopupProvider = useMemo(() => {
    switch (mapProvider?.name) {
      default:
        return MapGLPopup;
    }
  }, [mapProvider]);

  return <PopupProvider {...props} />;
};
